import { freeUserUpgradeStep } from '../utils';

export const accountSettingsNpoTour = {
  tourKey: 'account_settings_npo',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff', 'driver'],
    plans: null,
  },
  steps: [
    {
      title: 'tours.account-settings-npo.welcome.title',
      content: 'tours.account-settings-npo.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="account-settings-tabs"]',
      title: 'tours.account-settings-npo.settings-tabs.title',
      content: 'tours.account-settings-npo.settings-tabs.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="general-section"]',
      title: 'tours.account-settings-npo.general-info.title',
      content: 'tours.account-settings-npo.general-info.content',
      placement: 'top',
    },
    freeUserUpgradeStep,
  ],
};
